import { render } from "./SelectModule.vue?vue&type=template&id=491fc1e4&scoped=true"
import script from "./SelectModule.vue?vue&type=script&lang=js"
export * from "./SelectModule.vue?vue&type=script&lang=js"

import "./SelectModule.vue?vue&type=style&index=0&id=491fc1e4&scoped=true&lang=css"

import exportComponent from "/Users/priscillacancar/Documents/Coding/1) Engram-site/Engram/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-491fc1e4"]])

export default __exports__